(() => {
            // Order here = order under the product media (product claims first, then heading + icon row)
            const SECTION_IDS = ['section_mhKQ3b', 'section_jPmKpc', 'section_rzTwKb'];
            const desktop = window.matchMedia('(min-width: 750px)');
            const placeholders = new Map();

            const hostEl = () => {
              const media = document.querySelector('[data-testid="product-information-media"]');
              if (!media) return null;
              let host = media.querySelector('[data-product-below-media]');
              if (!host) {
                host = document.createElement('div');
                host.className = 'product-information__below-media';
                host.setAttribute('data-product-below-media', '');
                media.appendChild(host);
              }
              return host;
            };

            const collectSections = () => {
              const found = new Map();
              const mediaSection = document
                .querySelector('[data-testid="product-information-media"]')
                ?.closest('.shopify-section');

              const canMove = (el) => {
                if (!el || !el.classList?.contains('shopify-section')) return false;
                // Never move the main product section (it owns the media host)
                if (mediaSection && (el === mediaSection || el.contains(mediaSection))) return false;
                if (el.querySelector('[data-testid="product-information-media"]')) return false;
                return true;
              };

              SECTION_IDS.forEach((id) => {
                const el = document.querySelector(`.shopify-section[id$="__${id}"]`);
                if (canMove(el)) found.set(el.id, el);
              });

              document.querySelectorAll('.shopify-section:has([data-under-product-media])').forEach((el) => {
                if (canMove(el)) found.set(el.id, el);
              });

              // Heading + icon row share .products-criteria (product claims is moved via SECTION_IDS above)
              document.querySelectorAll('.shopify-section:has(.products-criteria)').forEach((el) => {
                if (el.querySelector('.product-claims') || el.querySelector('[class*="product-claims"]')) return;
                if (canMove(el)) found.set(el.id, el);
              });

              return Array.from(found.values());
            };

            const ensurePlaceholder = (section) => {
              if (placeholders.has(section.id)) return placeholders.get(section.id);
              const placeholder = document.createComment(`under-media:${section.id}`);
              section.parentNode?.insertBefore(placeholder, section);
              placeholders.set(section.id, placeholder);
              return placeholder;
            };

            const sync = () => {
              const sections = collectSections();

              if (!desktop.matches) {
                sections.forEach((section) => {
                  const placeholder = placeholders.get(section.id);
                  if (placeholder?.parentNode) {
                    placeholder.parentNode.insertBefore(section, placeholder);
                  }
                });
                return;
              }

              const host = hostEl();
              if (!host) return;

              sections.forEach((section) => {
                // Never move a section that contains the media host (throws HierarchyRequestError)
                if (!section || section === host || section.contains(host)) return;
                if (section.querySelector('[data-testid="product-information-media"], [data-product-below-media]')) {
                  return;
                }
                ensurePlaceholder(section);
                if (section.parentElement !== host) host.appendChild(section);
              });

              // Keep the moved sections in SECTION_IDS order inside the host
              const ordered = sections.filter((section) => section.parentElement === host);
              const current = Array.from(host.children).filter((el) => ordered.includes(el));
              if (ordered.some((el, i) => current[i] !== el)) {
                ordered.forEach((section) => host.appendChild(section));
              }
            };

            const start = () => {
              sync();
              // Retry briefly for theme editor / delayed section hydration
              let tries = 0;
              const timer = window.setInterval(() => {
                sync();
                tries += 1;
                if (tries >= 20) window.clearInterval(timer);
              }, 100);
            };

            start();
            desktop.addEventListener?.('change', sync);
            document.addEventListener('shopify:section:load', start);
            document.addEventListener('shopify:section:reorder', start);
          })();